import { compact, includes, uniq, without, isEmpty } from 'lodash';

export const getCleanFilter = <E extends string>(filter?: Array<E | 'all'> | string) => {
  if (!filter) return { filterArrayWithoutAll: [], shouldFilterByNotIn: false };

  const filterArray = typeof filter === 'string' ? uniq(compact(filter.split(','))) : filter;
  const filterArrayWithoutAll = without(filterArray, 'all') as E[];

  if (isEmpty(filterArrayWithoutAll)) return { filterArrayWithoutAll: [], shouldFilterByNotIn: false };

  return includes(filterArray, 'all')
    ? { filterArrayWithoutAll, shouldFilterByNotIn: true }
    : { filterArrayWithoutAll, shouldFilterByNotIn: false };
};
